import { Box, Grid, Paper, Typography, FormControl, Chip } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import SelectInput from "../../Components/InputComponents/SelectInput";
import TextInput from "../../Components/InputComponents/TextInput";
import { useEffect, useState } from "react";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const COLORS = ["#0088FE", "#FFBB28", "#00C49F", "#FFBB28"];

const BAR_COLOR = "#0088FE"; // red for cancellation rate

const JobsPostedChart = ({
  data,

  processList,
  processName,
  setProcessName,

  staffList,

  staffName,
  staffName2,
  staffName3,
  staffName4,
  staffName5,

  setStaffName,
  setStaffName2,
  setStaffName3,
  setStaffName4,
  setStaffName5,

  staffCancelRate,
  staffOfferStats,
  candidateByStaff,

  startDate,
  setStartDate,
  endDate,
  setEndDate,

  RecruitmentStageslist,
  recruitmentStage,
  setRecruitmentStage,

  staffInterviewScheduledList,

  statusList,
  interviewStatus,
  setInterviewStatus,
}) => (
  <Paper sx={{ boxShadow: "none" }}>
    <Grid container spacing={2}>
      {/* ---------------- ROW 1 ---------------- */}
      <Grid item xs={12} md={4}>
        {/* Cancellation Rate */}
        <Box
          sx={{
            border: "2px solid lightgrey",
            borderRadius: 2,
            p: 2,
            minHeight: { xs: "400px", md: "520px", lg: "400px" },
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              xl={6}
              alignContent={"center"}
            >
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  fontSize: "18px",
                  color: "#3e3e3e",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                }}
              >
                Cancellation Rate
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Staff
              </Typography>
              <SelectInput
                value={staffName3 || (staffList && staffList[0]?.ED_Id)}
                onChange={(e) => setStaffName3(e.target.value)}
                options={staffList?.map((item) => ({
                  value: item?.ED_Id,
                  label: item?.ED_Name,
                }))}
                placeholder="Select"
              />
            </Grid>

            <Grid item xs={12}>
              {staffCancelRate?.StaffName ? (
                <Box sx={{ mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* Chart */}
                    <Grid item xs={12} lg={12} xl={7}>
                      <ResponsiveContainer width="100%" height={200}>
                        <BarChart
                          data={[
                            {
                              name: staffCancelRate.StaffName || "Rate",
                              CancellationRate: parseFloat(
                                staffCancelRate.CancellationRate
                              ),
                            },
                          ]}
                        >
                          <XAxis dataKey="name" />
                          <YAxis
                            domain={[0, 100]}
                            tickFormatter={(v) => `${v}%`}
                          />
                          <Tooltip formatter={(val) => `${val}%`} />
                          <Bar dataKey="CancellationRate" barSize={60}>
                            <Cell fill={BAR_COLOR} />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </Grid>

                    {/* Extra Values */}
                    <Grid item xs={12} lg={12} xl={5}>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Total Applications:{" "}
                        <strong>{staffCancelRate.TotalApplications}</strong>
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Cancelled Applications:{" "}
                        <strong>{staffCancelRate.CancelledApplications}</strong>
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Cancellation Rate:{" "}
                        <strong>{staffCancelRate.CancellationRate}%</strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: "40px",
                      background: "white",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    No data to show
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        {/* Offer Status */}
        <Box
          sx={{
            border: "2px solid lightgrey",
            borderRadius: 2,
            p: 2,
            minHeight: { xs: "400px", md: "520px", lg: "400px" },
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              xl={6}
              alignContent={"center"}
            >
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  fontSize: "18px",
                  color: "#3e3e3e",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                }}
              >
                Offer Status
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Staff
              </Typography>
              <SelectInput
                value={staffName4 || (staffList && staffList[0]?.ED_Id)}
                onChange={(e) => setStaffName4(e.target.value)}
                options={staffList?.map((item) => ({
                  value: item?.ED_Id,
                  label: item?.ED_Name,
                }))}
                placeholder="Select"
              />
            </Grid>

            <Grid item xs={12}>
              {staffOfferStats?.StaffName ? (
                <Box sx={{ mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* Chart */}
                    <Grid item xs={12} lg={12} xl={7}>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart
                          data={[
                            {
                              name: "Offers",
                              Accepted: parseFloat(
                                staffOfferStats.OfferLetterAcceptedCount
                              ),
                              Rejected: parseFloat(
                                staffOfferStats.OfferLetterRejectedCount
                              ),
                            },
                          ]}
                          margin={{ top: 20, right: 20, left: 0, bottom: 20 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis allowDecimals={false} />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="Accepted" fill="#0088FE" barSize={40} />
                          <Bar dataKey="Rejected" fill="#FFBB28" barSize={40} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Grid>

                    {/* Extra Values */}
                    <Grid item xs={12} lg={12} xl={5}>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Offer Letter Accepted:{" "}
                        <strong>
                          {staffOfferStats.OfferLetterAcceptedCount}
                        </strong>
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Offer Letter Rejected:{" "}
                        <strong>
                          {staffOfferStats.OfferLetterRejectedCount}
                        </strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: "40px",
                      background: "white",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    No data to show
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        {/* Candidate By Staff */}
        <Box
          sx={{
            border: "2px solid lightgrey",
            borderRadius: 2,
            p: 2,
            minHeight: { xs: "400px", md: "520px", lg: "400px" },
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              xl={6}
              alignContent={"center"}
            >
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  fontSize: "18px",
                  color: "#3e3e3e",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                }}
              >
                Candidate By Staff
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Staff
              </Typography>
              <SelectInput
                value={staffName5 || staffList[0]?.ED_UserLoginId}
                onChange={(e) => setStaffName5(e.target.value)}
                options={staffList?.map((item) => ({
                  value: item?.ED_UserLoginId,
                  label: item?.ED_Name,
                }))}
                placeholder="Select"
              />
            </Grid>

            <Grid item xs={12}>
              {candidateByStaff?.StaffName ? (
                <Box sx={{ mt: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* Chart */}
                    <Grid item xs={12} lg={12} xl={7}>
                      <ResponsiveContainer width="100%" height={200}>
                        <BarChart
                          data={[
                            {
                              name: candidateByStaff?.StaffName,
                              Candidates: parseFloat(
                                candidateByStaff?.totalcandidate_Count
                              ),
                            },
                          ]}
                        >
                          <XAxis dataKey="name" />
                          <YAxis allowDecimals={false} />
                          <Tooltip
                            formatter={(val) => [`${val}`, "Candidates"]}
                          />
                          <Bar
                            dataKey="Candidates"
                            barSize={60}
                            fill="#1976d2"
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </Grid>

                    {/* Extra Values */}
                    <Grid item xs={12} lg={12} xl={5}>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Staff Name:{" "}
                        <strong>{candidateByStaff.StaffName}</strong>
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        Total Candidates:{" "}
                        <strong>{candidateByStaff.totalcandidate_Count}</strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: "40px",
                      background: "white",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    No data to show
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={1}>
        <Box
          sx={{
            border: "2px solid lightgrey",
            borderRadius: 2,
            p: 2,
            mb: 1,
            minHeight: {
              xs: "0px",
              sm: "0px",
              md: "550px",
              lg: "550px",
              xl: "500px",
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={6}
              xl={6}
              alignContent={"center"}
            >
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  fontSize: "18px",
                  color: "#3e3e3e",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                }}
              >
                Interview Scheduled
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Staff
              </Typography>
              <FormControl
                fullWidth
                size="small"
                sx={{ backgroundColor: "white" }}
              >
          
                <SelectInput
                  value={staffName2}
                  onChange={(e) => setStaffName2(e.target.value)}
                  options={staffList?.map((item) => ({
                    value: item?.ED_Id,
                    label: item?.ED_Name,
                  }))}
                  placeholder="Select"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Interview Status
              </Typography>
              <FormControl
                fullWidth
                size="small"
                sx={{ backgroundColor: "white" }}
              >
                <SelectInput
                  value={interviewStatus}
                  onChange={(e) => setInterviewStatus(e.target.value)}
                  options={statusList?.map((item) => ({
                    value: item?.JASL_Id,
                    label: item?.JASL_Name,
                  }))}
                  placeholder="Select Status"
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              {staffInterviewScheduledList?.length == 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                    marginTop: "60px",
                  }}
                >
                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: "40px",
                      background: "white",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    No data to show
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ position: "relative", top: "90px" }}>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                      data={staffInterviewScheduledList}
                      // margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="StaffName" />
                      <YAxis dataKey="CandidateCount" />

                      <Bar
                        dataKey="CandidateCount"
                        name="Candidates"
                        fill="#006CB8"
                        barSize={200}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12} sm={12} md={12} mb={1}>
        <Box
          sx={{
            border: "2px solid lightgrey",
            borderRadius: 2,
            p: 2,
            mb: 1,
            minHeight: {
              xs: "0px",
              sm: "0px",
              md: "400px",
              lg: "400px",
              xl: "400px",
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  fontSize: "18px",
                  color: "#3e3e3e",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                }}
              >
                Recruitment Process
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Staff
              </Typography>
              <SelectInput
                value={staffName || (staffList && staffList[0]?.ED_UserLoginId)}
                onChange={(e) => setStaffName(e.target.value)}
                options={staffList?.map((item) => ({
                  value: item?.ED_UserLoginId,
                  label: item?.ED_Name,
                }))}
                placeholder="Select"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Recruitment Process
              </Typography>
              <SelectInput
                value={processName}
                onChange={(e) => setProcessName(e.target.value)}
                options={processList?.map((item) => ({
                  value: item?.RP_Id,
                  label: item?.RP_Name,
                }))}
                placeholder="Select a Process"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Recruitment Stage
              </Typography>
              <SelectInput
                value={recruitmentStage}
                onChange={(e) => setRecruitmentStage(e.target.value)}
                options={RecruitmentStageslist?.map((item) => ({
                  value: item?.RPS_Id,
                  label: item?.RPS_Name,
                }))}
                placeholder="Select a Stage"
                customStyle={{ width: "100%" }}
                isDisabled={!processName}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Start Date
              </Typography>
              <TextInput
                value={startDate}
                type="date"
                onChange={(e) => setStartDate(e.target.value)}
                placeholder="Select Start Date"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                End Date
              </Typography>
              <TextInput
                value={endDate}
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                placeholder="Select End Date"
              />
            </Grid>

            <Grid item xs={12}>
              {data?.length == 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px", // adjust as needed or use '100%' if parent has height
                    width: "100%",
                    marginTop: "60px",
                  }}
                >
                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: "40px",
                      background: "white",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    No data to show
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    position: "relative",
                    top: "15px",
                  }}
                >
                  <ResponsiveContainer width="100%" minHeight={300}>
                    <BarChart
                      data={data}
                      margin={{
                        top: 5,
                        right: 10,
                        left: data?.every((item) => item.CompletedCount == 0)
                          ? -40
                          : 0,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        type="category"
                        dataKey="stage_name"
                        tick={{
                          fill: "#333",
                          fontSize: 14,
                          fontWeight: "bold",
                          fontFamily: "Geist, sans-serif",
                        }}
                      />
                      <YAxis
                        type="number"
                        tick={{
                          fill: "#333",
                          fontSize: 14,
                          fontWeight: "bold",
                          fontFamily: "Geist, sans-serif",
                        }}
                      />
                      <Tooltip />
                      <Legend />
                      <Bar
                        dataKey="CompletedCount"
                        fill="#006CB8"
                        name="Completed Count"
                      />
                      <Bar
                        dataKey="InProcessCount"
                        fill="#FF9800"
                        name="In Process Count"
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  </Paper>
);

const StaffReportView = ({
  data,

  processList,
  processName,
  setProcessName,

  staffList,
  staffName,
  staffName2,
  staffName3,
  staffName4,
  staffName5,

  setStaffName,
  setStaffName2,
  setStaffName3,
  setStaffName4,
  setStaffName5,

  staffCancelRate,
  staffOfferStats,
  candidateByStaff,

  startDate,
  setStartDate,

  endDate,
  setEndDate,

  RecruitmentStageslist,
  recruitmentStage,
  setRecruitmentStage,

  staffInterviewScheduledList,

  statusList,
  interviewStatus,
  setInterviewStatus,
}) => {
  const [dashboardCountData, setDashCountData] = useState();

  const getDashCount = async () => {
    try {
      const res = await axiosAPI?.get(`/dashboard/count`, {
        year: new Date().getFullYear(),
      });
      setDashCountData(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getDashCount();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
          px: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        >
          Staff Reports
        </Typography>
        {dashboardCountData?.totalStaffs ? (
          <Chip
            label={`Total Staff - ${dashboardCountData?.totalStaffs - 1}`}
            sx={{
              fontWeight: 600,
              fontFamily: "Geist, sans-serif",
              fontSize: "18px",
              color: "white",
              backgroundColor: "#006CB8",
              borderRadius: "8px",
              p: 1,
            }}
          />
        ) : null}
      </Box>
      <JobsPostedChart
        data={data}
        processList={processList}
        processName={processName}
        setProcessName={setProcessName}
        staffList={staffList}
        staffName={staffName}
        staffName2={staffName2}
        staffName3={staffName3}
        staffName4={staffName4}
        staffName5={staffName5}
        setStaffName={setStaffName}
        setStaffName2={setStaffName2}
        setStaffName3={setStaffName3}
        setStaffName4={setStaffName4}
        setStaffName5={setStaffName5}
        staffCancelRate={staffCancelRate}
        staffOfferStats={staffOfferStats}
        candidateByStaff={candidateByStaff}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        RecruitmentStageslist={RecruitmentStageslist}
        recruitmentStage={recruitmentStage}
        setRecruitmentStage={setRecruitmentStage}
        staffInterviewScheduledList={staffInterviewScheduledList}
        statusList={statusList}
        interviewStatus={interviewStatus}
        setInterviewStatus={setInterviewStatus}
      />
    </Box>
  );
};

export default StaffReportView;
